// extracted by mini-css-extract-plugin
export var children = "Portal-module--children--68c18";
export var container = "Portal-module--container--6ee9b";
export var insideContainer = "Portal-module--insideContainer--57b49";
export var purple = "Portal-module--purple--f88da";
export var swan = "Portal-module--swan--0b990";
export var swanContainer = "Portal-module--swanContainer--04cc9";
export var title = "Portal-module--title--bbb4e";